<div class="card charging-parks-card" [ngStyle]="{'margin-bottom': isOperator ? '1em' : '0'}">
  <div class="card-header card-title d-flex flex-wrap align-items-center gap-2">
    <h5 class="m-0 p-0" i18n="@@DashboardChargingParksUtilizationTitle">Auslastung pro Ladepark</h5>
    <div class="legend ms-auto d-flex flex-wrap gap-3 small text-muted" *ngIf="!loading && parks.length > 0">
      <span class="d-inline-flex align-items-center gap-1"><span class="legend-dot green"></span><span i18n="@@Ready">Bereit</span></span>
      <span class="d-inline-flex align-items-center gap-1"><span class="legend-dot orange"></span><span i18n="@@Charging">Lädt</span></span>
      <span class="d-inline-flex align-items-center gap-1"><span class="legend-dot blue"></span><span i18n="@@Busy">Belegt</span></span>
      <span class="d-inline-flex align-items-center gap-1"><span class="legend-dot grey"></span><span i18n="@@Offline">Offline</span></span>
      <span class="d-inline-flex align-items-center gap-1"><span class="legend-dot black"></span><span i18n="@@Unregistered">Unregistriert</span></span>
    </div>
  </div>
  <div class="card-body">
    <p *ngIf="loading" class="text-muted mb-0" i18n="@@Loading">Laden…</p>
    <p *ngIf="!loading && parks.length === 0" class="text-muted mb-0" i18n="@@DashboardChargingParksUtilizationNoParks">Keine Ladeparks (Ladestationsgruppen) vorhanden oder keine Ladepunkte zugeordnet.</p>
    <div *ngIf="!loading && parks.length > 0" class="parks-list">
      <div *ngFor="let park of parks" class="park-row">
        <div class="park-row-header">
          <span class="park-name">{{ park.groupName }}</span>
          <span class="park-stats">
            <span i18n="@@DashboardChargingParksUtilizationUsed">Belegt:</span>
            {{ (park.status?.charging ?? 0) + (park.status?.busy ?? 0) }} / {{ getMax(park) }}
            ({{ getUtilizationPercent(park) }} %)
          </span>
        </div>
        <div class="park-bar-wrap" *ngIf="getMax(park) > 0">
          <div class="progress-stacked park-bar">
            <div class="progress rounded-start" [style.width.%]="getSegmentPercent(park, 'online')">
              <div class="progress-bar green rounded-start" ngbTooltip="{{ park.status?.online ?? 0 }} bereit"></div>
            </div>
            <div class="progress rounded-0" [style.width.%]="getSegmentPercent(park, 'charging')">
              <div class="progress-bar orange rounded-0" ngbTooltip="{{ park.status?.charging ?? 0 }} laden"></div>
            </div>
            <div class="progress rounded-0" [style.width.%]="getSegmentPercent(park, 'busy')">
              <div class="progress-bar blue rounded-0" ngbTooltip="{{ park.status?.busy ?? 0 }} belegt"></div>
            </div>
            <div class="progress rounded-0" [style.width.%]="getSegmentPercent(park, 'offline')">
              <div class="progress-bar grey rounded-0" ngbTooltip="{{ park.status?.offline ?? 0 }} offline"></div>
            </div>
            <div class="progress rounded-end rounded-0" [style.width.%]="getSegmentPercent(park, 'unregistered')">
              <div class="progress-bar black rounded-end rounded-0" ngbTooltip="{{ park.status?.unregistered ?? 0 }} unregistriert"></div>
            </div>
          </div>
        </div>
        <div class="park-bar-wrap park-bar-empty" *ngIf="getMax(park) === 0">
          <div class="progress"><div class="progress-bar bg-secondary" style="width: 100%"></div></div>
          <span class="empty-label small text-muted" i18n="@@NoChargingPoints">Keine Ladepunkte</span>
        </div>
      </div>
    </div>
  </div>
</div>
